/**
 * Configuration de l'API
 */

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || 'http://127.0.0.1:8001',
  API_PREFIX: '/api',
  TIMEOUT: 30000, // 30 secondes
} as const

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    VERIFY_OTP: '/auth/verify-otp',
    CLERK: '/auth/clerk',
    LOGOUT: '/auth/logout',
    ME: '/auth/me',
  },
} as const

/** Publishable key present → Google sign-in UI is available */
export const isClerkConfigured = (): boolean =>
  Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY)

/**
 * Construit l'URL complète de l'endpoint
 */
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${API_CONFIG.API_PREFIX}${endpoint}`
}

